import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnChanges {
  @Input() displayLoader = false;
  @Input() diameter = 15;
  constructor() { }
  ngOnChanges(): void { }
}
